
























import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import AgentForm from "@/components/agent/AgentForm.vue";
import { agentApi } from "@/getinfo-api";
import { Agent as IAgent } from "@/api-v2/agent/models/agent";

@Component({
  components: { AgentForm, CPage }
})
export default class AgentEdit extends Vue {
  agent!: IAgent;
  isLoading: boolean = false;

  data() {
    return {
      agent: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "agents" },
        label: `Agents`
      },
      {
        to: { name: "agentView", params: { id: this.$route.params.id } },
        label: this.agent?.fullName
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  async saveHandler(agent: IAgent) {
    try {
      this.isLoading = true;
      const { data } = await agentApi.Agent.editAgent(this.agent.id!, agent);
      await this.$router.push({ name: "agentView", params: { id: data.id! } });
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  async deleteHandler(agentId: string) {
    try {
      this.isLoading = true;
      const response = await agentApi.Agent.deleteAgent(agentId);
      if (response.status === 204 || response.status === 200) {
        await this.$store.dispatch("successToast", {
          message: this.$tc(this.$translate.SuccessfullyDeleted)
        });
        await this.$router.push({ name: "agents" });
      }
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  cancelHandler() {
    this.$router.push({ name: "agents" });
  }

  async getAgent() {
    try {
      this.isLoading = true;
      const { data } = await agentApi.Agent.getAgent(this.$route.params.id);
      this.agent = data;
    } catch (e) {
      throw new Error(e);
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.getAgent();
  }
}
